export const FRAUD_ORDERS = 'fraud_orders';
export const LEGIT_ORDERS = 'legit_orders';

export const VERIFICATION_STATES = [FRAUD_ORDERS, LEGIT_ORDERS];

export const AMAZON_FILES_EXT = ['csv'];

export const ORDER_STATUSES_UNSAFE_FOR_ADDRESS_CHANGE = ['processing', 'processing_3pl'];

export default {};
